// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const GrailSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="GrailSignetIcon" ref={forwardedRef} {...props}>
      <path d="M15.57 13.309V5.266h-.01c-.122-1.016-1.508-1.68-3.228-1.967a12 12 0 0 0-.5-.072 1.338 1.338 0 0 0-2.346-.066 12 12 0 0 0-.5.04C6.943 3.41 5.166 4.11 5.028 5.267H5.019v2.805a1.994 1.994 0 0 0 0 3.873v2.203c0 .888.95 1.41 1.748 1.69.95.336 2.203.52 3.526.52a14 14 0 0 0 1.233-.055 2.653 2.653 0 1 0 4.043-2.993m-2.117-8.613c.541.199.838.415.96.57q.071.09.07.147c0 .13-.28.442-1.03.716a7 7 0 0 1-.76.223 10.8 10.8 0 0 1-2.4.251q-.511 0-.996-.04L8.524 7.567a13 13 0 0 0 1.77.122c1.581 0 3.174-.285 4.19-.84v6.015a2.64 2.64 0 0 0-1.785.333l-5.254-2.78a1.98 1.98 0 0 0-.391-1.651l2.903-3.774a1.34 1.34 0 0 0 1.931-.665 9 9 0 0 1 .437.07 7 7 0 0 1 1.127.3m-7.28.57c.123-.154.42-.371.961-.57a8 8 0 0 1 1.794-.398 10 10 0 0 1 .44-.042 1.3 1.3 0 0 0 .224.416L6.333 8.198A2 2 0 0 0 6.105 8.11V6.851a5 5 0 0 0 .622.28l.808-.873a6 6 0 0 1-.4-.13c-.75-.274-1.03-.585-1.03-.715 0-.037.02-.087.069-.147m4.971 9.977-.174.01a13 13 0 0 1-.677.018c-2.883 0-4.189-.862-4.189-1.124v-2.242a2 2 0 0 0 .632-.34l4.719 3.355a3 3 0 0 0-.047.303z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const GrailSignetIcon = /* @__PURE__ */ Object.assign(
  GrailSignetIconComponent,
  { displayName: 'GrailSignetIcon' },
);
